import { useEffect, useState } from "react"
import { BACKEND } from "../config/configEnvs"
import { FaGlobe, FaInfoCircle, FaSpinner, FaTimes } from "react-icons/fa"
import { Button, Pagination } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search';
import axios from "axios";
import HyDBoxItemContainer from "../components/proyectos/HyDBoxItemContainer";
import { useSelector } from "react-redux";
import PaginationItem from "../components/ui/components/Pagination";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";

const ProyectosHyD = () => {

  const user = useSelector((state) => state.auth.user)

  const [clients, setClients] = useState([])

  const [hydServices, sethydServices] = useState([])
  const [loadingStatus, setLoadingStatus] = useState(false)

  const [serviceFilters, setServiceFilters] = useState([])

  // Por defecto aparecen los proyectos que nos interesan
  const [statusFilters, setStatusFilters] = useState(["Por comenzar", "En proceso"])

  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(60)

  const [totalDocs, setTotalDocs] = useState(1)
  const [totalPages, setTotalPages] = useState(1)

  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")

  const [agencyWeb, setAgencyWeb] = useState(false)

  const [brandName, setBrandName] = useState("")

  const getClients = async () => { // Obtener los clientes
    try {
      setLoadingStatus(true)

      const body = {}

      let url = `${BACKEND}/api/userProcessesInterface/getClientsByServiceCategory?category=Hosting y dominio&page=${page}&limit=${limit}`

      if (brandName) {
        url += `&brandName=${brandName}`
      }

      if (statusFilters) {
        body.statusFilters = statusFilters
      }

      if (serviceFilters) {
        body.serviceFilters = serviceFilters
      }

      if (agencyWeb) {
        url += `&activoAgencia=${agencyWeb}`
      }

      if (startDate) {
        url += `&startDate=${new Date(startDate).toISOString()}`
      }

      if (endDate) {
        url += `&endDate=${new Date(endDate).toISOString()}`
      }

      const response = await axios.post(url, body)

      setClients(response.data.clients)
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)

      setLoadingStatus(false)

    } catch (error) {
      console.log(error)
    }
  }

  const getHyDServices = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/servicios?where[categoria][equals]=Hosting y dominio&limit=0`)
      sethydServices(response.data.docs)
    } catch (error) {
      console.log(error)
    }
  }

  const handleSearchClients = () => { // Buscamos clientes y colocamos página 1
    setPage(1)
    getClients()
  }

  const handleResetSearch = () => { // Resetea la búsqueda
    setBrandName(""); // Cambiar el estado
  };

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  useEffect(() => { // Solo se ejecuta cuando se vacea la barra de búsqueda
    if (brandName === "") {
      getClients(); // Solo se ejecuta cuando se reinicia la búsqueda
      setPage(1); // Reiniciar la paginación si es necesario
    }
  }, [brandName]);

  useEffect(() => { // Obtenemos los clientes
    getHyDServices()
    getClients()
  }, [])

  useEffect(() => { // Obtenemos los clientes cada que cambia la página y el límite
    getClients()
  }, [page, limit])

  const handlerChangeServiceFilter = (service, checked) => { // Manejador para el selector de servicios
    if (checked) {
      setServiceFilters((prev) => [...prev, service.id])
    } else {
      setServiceFilters((prev) => 
      prev.filter((serviceId) => serviceId !== service.id))
    }
  }

  const handlerChangeStatusFilter = (newStatus, checked) => { // Manejador para el selector de estados
    if (checked) {
      setStatusFilters((prev) => [...prev, newStatus])
    } else {
      setStatusFilters((prev) =>
      prev.filter((status) => status !== newStatus))
    }
  }

  useEffect(() => {
    getClients()
  }, [agencyWeb, startDate, endDate])

  useEffect(() => {
    const timeout = setTimeout(() => {
      getClients();
    }, 1500);
  
    return () => clearTimeout(timeout); // Limpia el timeout si el efecto se vuelve a ejecutar
  }, [serviceFilters, statusFilters]);

  // Permisos
  const [permissions, setPermissions] = useState({
    isAdmin: false,
    isBossArea: false,
  });

  const definePermissions = (user) => {
    const updatedPermissions = {
      isAdmin: user.area.toUpperCase() === "ADMINISTRACION" && user.puesto.toUpperCase() !== "ASISTENTE",
      isBossArea: user.area.toUpperCase() === "SOFTWARE" && user.puesto.toUpperCase() === "DESARROLLADOR FULL STACK",
    };
    setPermissions(updatedPermissions);
  };
  
  useEffect(() => {
    if (user) definePermissions(user);
  }, [user]);

  return (
    <div className="flex flex-col h-screen w-full">

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <div className="flex items-center gap-4 py-4">
            <FaGlobe className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Proyectos hosting y dominios</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">
           
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Límite:</span>
              <select
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
                <option value="60">60</option>
              </select>
            </div>

            <div className="relative w-full">
              <input
                type="text"
                placeholder="Buscar marca"
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={brandName}
                onChange={(e) => setBrandName(e.target.value)}
              />
              {brandName && (
                <FaTimes
                  onClick={() => handleResetSearch()}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>

            <div>
              <Button 
                variant="contained"
                endIcon={<SearchIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => handleSearchClients()}
              >
                Buscar
              </Button>
            </div>

          </div>

        </div>
      </div>
      
      {/* Filtros de fechas */} 
      <div className="flex flex-row items-center justify-center bg-gray-100 mt-0.5 gap-8">

        <div className="flex flex-row w-full items-center justify-center gap-4 overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">

          {/* Contenedor de Fecha inicio */}
          <div className="flex flex-row items-center justify-center gap-4">
            <span className="text-xs">Fecha inicio</span>
            <input 
              type="date" 
              className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>  

          {/* Contenedor de Fecha fin */}
          <div className="flex flex-row items-center justify-center gap-4">
            <span className="text-xs">Fecha fin</span>
            <input 
              type="date" 
              className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div> 

          {/* Activo agencia */}
          <div className="flex flex-row items-center justify-center gap-4">
            <span className="text-xs">Activos Agencia</span>
            <input
              type="checkbox"
              className="rounded-md border-gray-400 hover:cursor-pointer"
              checked={agencyWeb}
              onChange={(e) => setAgencyWeb(e.target.checked)}
            />
          </div>

        </div>

      </div>

      {/* HyD services */}     
      <div className="flex flex-row items-center justify-center bg-gray-100 mt-0.5 py-2 px-4">
        <div className="flex flex-row w-full items-center justify-center overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          {hydServices.map((service) => (
            <div
              key={service.id}
              className="flex flex-row items-center justify-center gap-1 pr-5 border-r pl-5 border-gray-300 last:pr-0 last:border-r-0"
            >
              <span className="text-xs font-bold">{service.name}</span>
              <input
                type="checkbox"
                className="rounded-md border-gray-400 hover:cursor-pointer"
                checked={serviceFilters.includes(service.id)}
                onChange={(e) =>
                  handlerChangeServiceFilter(service, e.target.checked)
                }
              />
            </div>
          ))}
        </div>
      </div>

      {/* Service status */}
      <div className="flex flex-row items-center justify-center bg-gray-100 mt-0.5 mb-0.5 py-2 px-4">
        <div className="flex flex-row w-full items-center justify-center overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row items-center justify-center gap-1 pr-5 border-r pl-5 border-gray-300">
            <span className="text-xs font-bold">Por comenzar</span>
            <input
              type="checkbox"
              className="rounded-md border-gray-400 hover:cursor-pointer"
              checked={statusFilters.includes("Por comenzar")}
              onChange={(e) =>
                handlerChangeStatusFilter("Por comenzar", e.target.checked)
              }
            />
          </div>

          <div className="flex flex-row items-center justify-center gap-1 pr-5 border-r pl-5 border-gray-300">
            <span className="text-xs font-bold">En proceso</span>
            <input
              type="checkbox"
              className="rounded-md border-gray-400 hover:cursor-pointer"
              checked={statusFilters.includes("En proceso")}
              onChange={(e) =>
                handlerChangeStatusFilter("En proceso", e.target.checked)
              }
            />
          </div>

          <div className="flex flex-row items-center justify-center gap-1 pr-5 border-r pl-5 border-gray-300">
            <span className="text-xs font-bold">Terminado con exito</span>
            <input
              type="checkbox"
              className="rounded-md border-gray-400 hover:cursor-pointer"
              checked={statusFilters.includes("Terminado con exito")}
              onChange={(e) =>
                handlerChangeStatusFilter("Terminado con exito", e.target.checked)
              }
            />
          </div>

          <div className="flex flex-row items-center justify-center gap-1 pr-5 border-r pl-5 border-gray-300">
            <span className="text-xs font-bold">Abandonado</span>
            <input
              type="checkbox"
              className="rounded-md border-gray-400 hover:cursor-pointer"
              checked={statusFilters.includes("Abandonado")}
              onChange={(e) =>
                handlerChangeStatusFilter("Abandonado", e.target.checked)
              }
            />
          </div>

          <div className="flex flex-row items-center justify-center gap-1 pr-5 pl-5">
            <span className="text-xs font-bold">Congelado</span>
            <input
              type="checkbox"
              className="rounded-md border-gray-400 hover:cursor-pointer"
              checked={statusFilters.includes("Congelado")}
              onChange={(e) =>
                handlerChangeStatusFilter("Congelado", e.target.checked)
              }
            />
          </div>
        </div>
      </div>
      
      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
          <LoadingScreen />
          ) : (
            clients.length === 0 ? (
              <NoDataScreen />
            ) : (
              <table className="w-full table-fixed">
                <thead className="bg-white sticky top-0 z-50">
                  <tr className="text-gray-700 text-center text-[10px] font-semibold">

                    <td className="w-[15%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      <div>
                        Cliente
                      </div>
                    </td>

                    {hydServices
                      .filter((service) => serviceFilters.length === 0 || serviceFilters.includes(service.id)) // Mostrar todos si no hay filtros seleccionados, de lo contrario, filtrar por los seleccionados
                      .map((service) => (
                        <td
                          key={service.id}
                          className="px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red"
                        >
                          <div>{service.name}</div>
                        </td>
                      ))
                    }

                  </tr>
                </thead>

                <tbody>
                  {clients.map((client) => (
                    <tr 
                      key={client.id}                     
                      className="text-xs py-2 w-full hover:bg-gray-100 transition-all duration-100"
                    >
                      <td 
                        scope="row" 
                        className="max-w-[20px] px-4 py-2 max-w-xs font-bold border border-gray-300 text-center hover:cursor-pointer hover:underline transition-all duration-100"
                      >
                        <a 
                          href={`/home/seguimiento/${client.id}`}
                          target="_blank" 
                          rel="noopener noreferrer"
                        >
                          {client.nombreComercial}
                        </a>
                      </td>

                      {hydServices
                        .filter((service) => serviceFilters.length === 0 || serviceFilters.includes(service.id)) // Mostrar todos si no hay filtros seleccionados, de lo contrario, filtrar por los seleccionados
                        .map((service) => (
                          <HyDBoxItemContainer
                            key={service.id} 
                            service={service} 
                            client={client}
                            user={user}
                            permissions={permissions}
                            allServiciosList={hydServices}
                          />
                        ))
                      }

                    </tr>
                  ))}

                </tbody>
              </table>  
            )
          )
        }
      </div>

      {/* Paginador */}
      <PaginationItem
        actualDocs={clients.length}
        totalDocs={totalDocs}
        entity={"clientes"}
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={handlePageChange}
      />

    </div>    
  )
}

export default ProyectosHyD